import React, { Component } from 'react';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';

import classes from './ConfigurationScreenContent.css';
import Aux from '../../../hoc/Aux';

class ConfigurationScreenContentPassword extends Component {
  render() {
    return (
      <Aux>
        <div className="container-fluid">
          <div className="row">
            <div className="col" />
            <div className={`col-8 ${classes.CardContainer}`}>
              <div className={`row ${classes.CardcontainerPadding}`}>
                <div className="col-6">
                  <h4>Moramma is passwordless</h4>
                  <p>We don&apos;t use the password. You don&apos;t need to set or change your password. You can only change the email of your account</p>
                </div>
                <div className="col-6 align-self-center">
                  <img src={require('./../../../assets/img/pswless_img.png')} alt="img-psw" className="img-fluid" />
                </div> 
              </div>
              <div className={`row ${classes.CardContainerItem}`}>
                <div className="col">
                  <p>Update Email</p>
                </div>
                <div className={`col-5 ${classes.TxtRight}`}>
                  <p>
                    <CheckCircleIcon className={classes.IcColor} /> 
                    Last update: 18/02/19
                  </p>
                </div>
              </div>
            </div>
            <div className="col" />
          </div>
        </div>
      </Aux>
    );
  }
} 

export default ConfigurationScreenContentPassword;
